const GPS_STRATEGY_TYPES = {
  ENFORCED: 'enforced',
  UNENFORCED: 'unenforced',
  WARNING: 'warning',
};
export default GPS_STRATEGY_TYPES;
